import CamLoading from "graphics/icons/SideVideo/CamLoading";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { selectCurrentUserAttributes } from "slices/authSlice";
import {
  MY_BOARD,
  selectMePinnedShare,
  selectMeShout,
  selectMyLuid,
  selectSpaceLayoutValue,
  openMyBoard,
} from "slices/spaceMediaSlice";
import {
  selectMeCamera,
  selectMeScreenTrackId,
  selectMeSharing,
} from "slices/spaceMyMediaSlice";
import { selectCurrentCameraTrackId } from "slices/devicesSlice";
import useAttachCameraTrack from "components/Hooks/useAttachCameraTrack";
import BoardImage from "../Board/BoardImage/BoardImage";

const MyMedia = () => {
  const currentCameraTrackId = useSelector(selectCurrentCameraTrackId);
  const meCamera = useSelector(selectMeCamera);
  const myLuid = useSelector(selectMyLuid);
  const given_name = useSelector(selectCurrentUserAttributes).given_name;
  const meScreenActive = useSelector(selectMeScreenTrackId);
  const meSharing = useSelector(selectMeSharing);
  const spaceLayout = useSelector(selectSpaceLayoutValue);
  const meShout = useSelector(selectMeShout);
  const mePinnedShare = useSelector(selectMePinnedShare);
  const cameraElement = useRef();

  useAttachCameraTrack(cameraElement);

  return (
    <div
      className={`my-media`}
      style={
        meScreenActive || meCamera || meSharing === "board"
          ? null
          : { display: "none" }
      }
    >
      <video
        id="myShareElement"
        className={`${mePinnedShare || meShout ? "shouting" : ""}`}
        style={meScreenActive ? null : { display: "none" }}
        autoPlay
        muted
        playsInline
      ></video>
      {meCamera && !currentCameraTrackId && (
        <div className="video-loading">
          <CamLoading />
        </div>
      )}
      <video
        id="myCameraElement"
        ref={cameraElement}
        className={`camera ${meShout ? "shouting" : ""}`}
        style={currentCameraTrackId && meCamera ? null : { display: "none" }}
        autoPlay
        muted
        playsInline
      ></video>
      <BoardImage
        luid={myLuid}
        given_name={given_name}
        onClick={openMyBoard}
        shown={meSharing === "board" && spaceLayout !== MY_BOARD && myLuid}
      />
    </div>
  );
};
export default MyMedia;
